import { getEnvVar } from '@smx-ui-common/util/get-env-var';

export class API {
    public static STATUS_200 = 200;

    public static STATUS_302 = 302;

    public static STATUS_400 = 400;

    public static URL_GRAPHQL = getEnvVar('URL_GRAPHQL');

    public static GRAPHQL_TOKEN = getEnvVar('GRAPHQL_TOKEN');

    public static PROJECT_FILTER = getEnvVar('PROJECT_FILTER');

    public static DRAWINGS_S3_URL = getEnvVar('DRAWINGS_S3_URL');

    public static DRAWINGS_RAPI_URL = getEnvVar('DRAWINGS_RAPI_URL');

    public static SMX5_API_URL = getEnvVar('SMX5_API_URL');

    public static APRYSE_LICENSE = getEnvVar('APRYSE_LICENSE');
}
